<template>
	<div class="main">
		<div class="ss">
			<view style="padding: 15rpx 0%;">
					<uni-steps :options="list1" :active="active" active-color="#fd8b4d" />
			</view>
		</div>

		<div class="top">
			<div class="address">
				<div class="imag"><img class="img" src="../../static/images/ym/dingwei.png" alt=""></div>
				<div class="adr">
					<div class="addre">爱康国宾西安曲江分院</div>
					<div class="time">预约时间 <span class="alltime"> 2022-11-15 08:00-10:30</span></div>

				</div>
			</div>
			<div>
				<div class="xm">
					<div class="zi">共32项检查项目</div>
					<img class="xm_img" src="../../static/images/tabBar/fuhao.png" alt="">
				</div>
			</div>
		</div>

		<div class="demand">
			<img class="demand_img" src="../../static/images/ym/jh.png" alt="">
			<div>您可根据自身需求，自愿选择加项。</div>
		</div>

		<h4 class="h">大家都在选</h4>

		<div class="content">
			<div class="content_top">
				<div class="content_cent">
					<div class="content_left">全身防癌筛查</div>
					<div class="content_right">限时优惠</div>
				</div>
				<div class="content_bottom">肿痛标志物检测，覆盖多种高发癌种</div>
			</div>
			<div class="core">
				<view class="rido">
					<uni-data-checkbox v-model="value" :localdata="range" @change="change"></uni-data-checkbox>
				</view>
				<div class="Price">
					<img class="Price_img" src="../../static/images/ym/taihao.png">
					<div class="pic">￥176.80</div>
				</div>
			</div>
		</div>

		<div class="nose">
			<div class="nose_top">
				<div class="content_cent">
					<div class="content_left">鼻癌专项检测</div>
					<div class="content_right">限时优惠</div>
				</div>
				<div class="content_bottom">鼻咽癌景我国最常见的恶性钟瘤之一，东南各省尤为高发，</div>
			</div>
			<div class="core2">
				<view class="rido2">
					<uni-data-checkbox v-model="value" :localdata="range1" @change="change"></uni-data-checkbox>
				</view>
				<div class="Price2">
					<img class="Price2_img" src="../../static/images/ym/taihao.png">
					<div class="pic2">￥232.00</div>
				</div>
			</div>
		</div>

		<div class="activity">
			每满3000减300元，已减1200元
		</div>

		<div class="bottom">
			<button @click="goBack" class="bottom_btn">上一步</button>
			<div class="allList">
				<div class="active">
					<div class="all">合计</div>
					<div class="allpic">￥1099.00</div>
				</div>

				<div class="choice">选择加项0项.升级项0项</div>
			</div>
			<button class="bottom_btn" @click="goto">下一步</button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				active: 1,
				value: 0,
				range: [{
						"value": 0,
						"text": "人纤维蛋白原降解产物(DR-70) "
					},
					{
						"value": 1,
						"text": "人纤维蛋白原降解产物(DR-70)"
					},
				],
				range1: [{
					"value": 0,
					"text": "安鼻测"
				}, ],
				list1: [{
					title: '选择分院'
				}, {
					title: '选择加项'
				}, {
					title: '确认信息'
				}, ]
			};
		},
		methods: {
			change() {
				if (this.active < this.list1.length - 1) {
					this.active += 1
				} else {
					this.active = 0
				}
			},
			change(e) {
				console.log('e:', e);
			},
			goto() {
				uni.navigateTo({
					url: '/pages/about/about'
				})
			},
			goBack(){
				uni.navigateBack({
					url:'/pages/physicalAppointment/physicalAppointment'
				})
			}
		}
	}
</script>

<style lang="scss">
	.main {
		height: 1380rpx;
		background-color: #f2f4f3;
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.ss {
		height: 100rpx;
		width: 100%;
		background-color: #fff;
	}

	.top {
		width: 720rpx;
		height: 260rpx;
		background-color: #fff;
		margin: 20rpx 10rpx;
		border-radius: 3%;
	}

	.address {
		border: 2rpx solid #f2f2f2;
		display: flex;
		height: 160rpx;
	}

	.imag {
		width: 75rpx;
		height: 75rpx;
		margin: 40rpx 25rpx;
	}

	.img {
		width: 75rpx;
		height: 75rpx;
	}

	.addre {
		padding: 20rpx 0rpx;
		font-weight: 400;
	}

	.time {
		font-size: 30rpx;
	}

	.alltime {
		font-size: 30rpx;
		color: #e4815b;
		padding: 0rpx 20rpx;
	}

	.xm {
		display: flex;
	}

	.zi {
		font-size: 34rpx;
		height: 80rpx;
		line-height: 80rpx;
		padding-left: 20rpx;
	}

	.xm_img {
		margin-left: 370rpx;
		margin-top: 30rpx;
		width: 40rpx;
		height: 40rpx;
	}

	.demand {
		width: 720rpx;
		background-color: #fff6e5;
		font-size: 32rpx;
		height: 90rpx;
		line-height: 100rpx;
		display: flex;
	}

	.demand_img {
		width: 40rpx;
		height: 40rpx;
		margin: 26rpx 15rpx;
	}

	.h {
		margin: 28rpx 10rpx;
		font-weight: 600;
		margin-right: 580rpx;
	}

	.content {

		width: 720rpx;
		height: 352rpx;
		background: #fff;
		margin: 0rpx 10rpx;
		border-radius: 3%;
	}

	.content_top {
		height: 130rpx;
		border-bottom: 1rpx solid #f2f2f2;
	}

	.content_cent {
		display: flex;
	}

	.content_left {
		font-size: 36rpx;
		margin: 15rpx 20rpx;
		font-weight: 600;
	}

	.content_right {
		width: 112rpx;
		height: 43rpx;
		border-radius: 5%;
		text-align: center;
		margin-left: 300rpx;
		margin-top: 15rpx;
		font-size: 24rpx;
		color: #fff;
		background-color: #fb5241;
	}

	.content_bottom {
		font-size: 25rpx;
		color: #a5a5a5;
		margin: 0rpx 20rpx;
	}

	.core {
		display: flex;
	}

	.rido {
		width: 440rpx;
		height: 68rpx;
		margin: 24rpx;
	}

	.Price {
		width: 230rpx;
		height: 68rpx;
		margin: 20rpx 0rpx;
		display: flex;
		line-height: 68rpx;
	}

	.Price_img {
		width: 40rpx;
		height: 40rpx;
		margin: 10rpx;
		margin-right: 40rpx;
	}

	.pic {
		font-size: 26rpx;
	}

	.nose {
		width: 720rpx;
		height: 260rpx;
		background: #fff;
		margin: 0rpx 10rpx;
		border-radius: 3%;
		margin-top: 15rpx;
	}

	.nose_top {
		height: 156rpx;
		border-bottom: 1rpx solid #f2f2f2;
	}

	.content_cent {
		display: flex;
	}

	.content_left {
		font-size: 36rpx;
		margin: 15rpx 20rpx;
		font-weight: 600;
	}

	.content_right {
		width: 112rpx;
		height: 43rpx;
		border-radius: 5%;
		text-align: center;
		margin-left: 300rpx;
		margin-top: 15rpx;
		font-size: 24rpx;
		color: #fff;
		background-color: #fb5241;
	}

	.content_bottom {
		width: 440rpx;
		font-size: 25rpx;
		color: #a5a5a5;
		margin: 0rpx 20rpx;
	}

	.core2 {
		display: flex;
	}

	.rido2 {
		width: 210rpx;
		height: 68rpx;
		margin: 20rpx;
	}

	.Price2 {
		width: 230rpx;
		height: 68rpx;
		margin: 20rpx 0rpx;
		display: flex;
		line-height: 68rpx;
	}

	.Price2_img {
		width: 40rpx;
		height: 40rpx;
		margin-top: 10rpx;
		margin-right: 280rpx;
	}

	.pic2 {
		font-size: 26rpx;
	}

	.activity {
		background-color: #fff3ea;
		height: 70rpx;
		font-size: 25rpx;
		color: #ff923a;
		text-align: center;
		line-height: 60rpx;
	}

	.bottom {

		display: flex;
		height: 85rpx;
	}

	.bottom_btn {
		margin: 0rpx;
		width: 160rpx;
		height: 85rpx;
		font-size: 25rpx;
		color: #FFF;
		background-color: #ff923b;
		border-radius: 0;
	}

	.allList {
		width: 410rpx;
		height: 74rpx;
		margin: 5rpx 20rpx;
	}

	.active {
		height: 36rpx;
		display: flex;
		font-size: 25rpx;
	}

	.all {
		line-height: 44rpx;
	}

	.allpic {
		font-size: 16px;
		color: #f36727;
		font-weight: 600;
	}

	.choice {
		font-size: 22rpx;
		margin-top: 6rpx;
		color: #c9c8c9;
	}
</style>
